import PageType from '../common/PageType.jsx';

const Kit = {
    _kit: (config) => (config && config.documents && config.documents.kit) || {},
    _kitConfig: (kit, pageType) => {
        switch (pageType) {
            case Kit.Context.Button.Primary:
            case Kit.Context.Button.Secondary:
                return kit[Kit.Type.Button] && kit[Kit.Type.Button][pageType];
            case Kit.Context.Cell.Artist.Grid:
            case Kit.Context.Cell.Blog:
            case Kit.Context.Cell.Exhibition.Grid:
            case Kit.Context.Cell.Exhibition.Parallax:
            case Kit.Context.Cell.Inventory.Grid:
            case Kit.Context.Cell.Inventory.Waterfall:
            case Kit.Context.Cell.RecentlyViewed:
                return kit[Kit.Type.Cell] && kit[Kit.Type.Cell][pageType];
            case Kit.Context.Global.Header1:
            case Kit.Context.Global.Header2:
            case Kit.Context.Global.Header3:
            case Kit.Context.Global.Header4:
            case Kit.Context.Global.Header5:
            case Kit.Context.Global.Header6:
            case Kit.Context.Global.Paragraph:
                return kit[Kit.Type.Global] && kit[Kit.Type.Global][pageType];
            case PageType.Cart:
            case PageType.SearchResults:
                return kit[PageType.Custom];
            default:
                return kit[pageType];
        }
    },
    brand: (config) => {
        const kit = (config && config.documents && config.documents[Kit.Type.Presentation] && config.documents[Kit.Type.Presentation].kit) || {};
        return kit[Kit.Type.Brand] || {};
    },
    designKit: (config, context, index = 0) => {
        const kit = Kit._kit(config);
        const designKit = Kit._kitConfig(kit, context);
        return designKit && designKit.length > index && designKit[index];
    },
    kit: (config, pageType) => {
        const kit = Kit._kit(config);
        let pageKit = Kit._kitConfig(kit, pageType);
        if (pageKit && pageKit.page) {
            pageKit = pageKit.page;
        }
        return pageKit;
    },
    presentationKit: (config, pageType, context, index = 0) => {
        const kit = (config && config.documents && config.documents[Kit.Type.Presentation] && config.documents[Kit.Type.Presentation].kit) || {}
        let pageKit = kit[pageType]
        if (pageKit && pageKit.page) {
            pageKit = pageKit.page;
        }
        if (context && pageKit && pageKit[context]) {
            pageKit = pageKit[context][index];
        }
        return pageKit;
    },

    Button: {
        token: 'BUTTON_TEXT',

        clearBlockConfig: (blockConfig) => {
            if (!blockConfig || !blockConfig.config) {
                return;
            }
            const propNamesString = [
                'backgroundColor',
                'borderBottomColor',
                'borderBottomStyle',
                'borderLeftColor',
                'borderLeftStyle',
                'borderRightColor',
                'borderRightStyle',
                'borderTopColor',
                'borderTopStyle'
            ];
            const propNamesObject = [
                'borderRadius',
                'borderBottomWidth',
                'borderLeftWidth',
                'borderRightWidth',
                'borderTopWidth'
            ]
            for (let key in blockConfig.config) {
                if (!blockConfig.config[key]) {
                    continue;
                }
                switch (key) {
                    case 'layout':
                        const propNames = [
                            'height',
                            'paddingBottom',
                            'paddingLeft',
                            'paddingRight',
                            'paddingTop',
                            'marginBottom',
                            'marginLeft',
                            'marginRight',
                            'marginTop',
                            'width'
                        ];
                        for (let propName of propNames) {
                            if (blockConfig.config[key][propName]) {
                                blockConfig.config[key][propName].value = '';
                            }
                        }
                        break;
                    default:
                        for (let propName of propNamesString) {
                            if (blockConfig.config[key][propName]) {
                                blockConfig.config[key][propName] = undefined;
                            }
                        }
                        for (let propName of propNamesObject) {
                            if (blockConfig.config[key][propName]) {
                                blockConfig.config[key][propName].value = '';
                            }
                        }
                        break;
                }
            }
        },

        updateBlockDesign: (blockConfig, designKitConfig) => {
            if (!blockConfig || !blockConfig.config || !designKitConfig || !designKitConfig.config) {
                return;
            }
            const testString = '<span';
            for (let key in blockConfig.config) {
                if (key == 'layout' || !blockConfig.config[key] || !designKitConfig.config[key]) {
                    continue;
                }
                const blockConfigDesign = blockConfig.config[key].design;
                const designKitBlockConfig = designKitConfig.config[key];
                const designKitConfigDesign = designKitBlockConfig.design;
                if (!blockConfigDesign || !designKitConfigDesign || !designKitBlockConfig.typeStyle) {
                    continue;
                }
                const components = blockConfigDesign.split('<p');
                let design = '';
                for (let component of components) {
                    if (!component) {
                        continue;
                    }
                    let index = component.indexOf(testString);
                    if (index < 0) {
                        continue;
                    }
                    index += testString.length;
                    let end = component.indexOf('>', index);
                    if (end < 0) {
                        continue;
                    }
                    index = end + 1;
                    end = component.lastIndexOf('</span>');
                    if (end < 0) {
                        continue;
                    }
                    const contentString = component.substring(index, end);
                    design += `<p class="${designKitBlockConfig.typeStyle}" style="text-align:${designKitBlockConfig.alignment || 'center'};"><span data-heading="${designKitBlockConfig.typeStyle}">${contentString}</span></p>`
                }
                if (design) {
                    blockConfig.config[key].design = design;
                }
            }
        }
    },

    Page: {
        // _defaultPropNames: ['marginLeft', 'marginRight', 'maxWidth', 'paddingLeft', 'paddingRight'],
        currentValue: (_options) => {
            const options = _options || {};
            if (options.inLayout == true) {
                return;
            }
            let pageKit;
            switch (options.pageType) {
                case PageType.Presentation:
                    pageKit = Kit.presentationKit(options.config, PageType.Custom);
                    break;
                default:
                    pageKit = Kit.kit(options.config, options.pageType);
                    break;
            }
            let propertyName = options.name;
            switch (propertyName) {
                case 'marginLeft':
                case 'marginRight':
                case 'paddingLeft':
                case 'paddingRight':
                    if (options.blockConfig) {
                        switch (options.blockConfig.type) {
                            case Kit.Type.ArtistDetail:
                            case Kit.Type.BlogPost:
                            case Kit.Type.CustomPage:
                            case Kit.Type.ExhibitionDetail:
                            case Kit.Type.InventoryDetail:
                            case PageType.Cart:
                            case PageType.SearchResults:
                                return;
                        }
                    }
                    break;
                case 'marginBottom':
                case 'marginTop':
                case 'paddingBottom':
                case 'paddingTop':
                    switch (options.pageType) {
                        case Kit.Type.HeaderText1:
                        case Kit.Type.HeaderText2:
                        case Kit.Type.HeaderText3:
                            break;
                        default:
                            if (options.blockConfig) {
                                switch (options.blockConfig.type) {
                                    case Kit.Type.ArtistDetail:
                                    case Kit.Type.BlogPost:
                                    case Kit.Type.CustomPage:
                                    case Kit.Type.ExhibitionDetail:
                                    case Kit.Type.InventoryDetail:
                                    case PageType.Cart:
                                    case PageType.SearchResults:
                                        break;
                                    default:
                                        return;
                                }
                            }
                    }
                    break;
            }
            if (!pageKit || pageKit[propertyName] == undefined) {
                return;
            }
            let value = pageKit[propertyName];
            if (value.unit) {
                if (value.value != undefined && value.value.length > 0) {
                    value = `${value.value}${value.unit}`;
                } else {
                    value = undefined;
                }
            }
            return value;
        },
        maxWidth: (config, pageType) => {
            let pageKit;
            switch (pageType) {
                case PageType.Presentation:
                    pageKit = Kit.presentationKit(config, PageType.Custom);
                    break;
                default:
                    pageKit = Kit.kit(config, pageType);
                    break;
            }
            if (pageKit && pageKit.maxWidth && pageKit.maxWidth.value && pageKit.maxWidth.value.length > 0) {
                return `${pageKit.maxWidth.value}${pageKit.maxWidth.unit}`;
            }
        },
        updateComponentStyle: (style, config, pageType, propertyNames) => {
            let pageKit;
            switch (pageType) {
                case PageType.Presentation:
                    pageKit = Kit.presentationKit(config, PageType.Custom);
                    break;
                default:
                    pageKit = Kit.kit(config, pageType);
                    break;
            }
            if (!style || !pageKit) {
                return style;
            }
            const _propertyNames = propertyNames || ['marginLeft', 'marginRight', 'paddingLeft', 'paddingRight'];
            _propertyNames.forEach((name) => {
                if (!style[name] && pageKit[name]) {
                    if (pageKit[name].value == undefined) {
                        style[name] = pageKit[name];
                    } else if (pageKit[name].value && pageKit[name].value.length > 0) {
                        style[name] = `${pageKit[name].value}${pageKit[name].unit}`;
                    }
                }
            });
            return style;
        }
    },

    Context: {
        Brand: {
            Company: 'company',
            Logo: 'logo'
        },
        Button: {
            Custom: 'custom',
            Primary: 'primary',
            Secondary: 'secondary'
        },
        Cell: {
            Artist: {
                Grid: 'artist_grid'
            },
            Blog: 'blog',
            Exhibition: {
                Grid: 'show_grid',
                Parallax: 'show_parallax'
            },
            Inventory: {
                Grid: 'inventory_grid',
                Waterfall: 'inventory_waterfall'
            },
            RecentlyViewed: 'recently_viewed'
        },
        Global: {
            Header1: 'h1',
            Header2: 'h2',
            Header3: 'h3',
            Header4: 'h4',
            Header5: 'h5',
            Header6: 'h6',
            Paragraph: 'p'
        },
        Presentation: {
            Company: 'company',
            Description: 'description',
            InquireButton: 'inquireButton',
            Subtitle: 'subtitle',
            Title: 'title'
        }
    },

    Type: {
        ArtistDetail: PageType.ArtistDetail,
        BlogPost: PageType.Content.Blog,
        Brand: 'brand',
        Button: 'button',
        Cell: 'cell',
        CustomPage: PageType.Custom,
        ExhibitionDetail: PageType.ExhibitionDetail,
        Global: 'global',
        InquirePopup: PageType.Popup.Inquire,
        InventoryDetail: PageType.InventoryDetail,
        OfferPopup: PageType.Popup.Offer,
        Presentation: PageType.Presentation,
        Template: 'templates',
        Version: 'version',

        // DEPRECATED
        HeaderText1: 'headerText1',
        HeaderText2: 'headerText2',
        HeaderText3: 'headerText3'
    }
}
export default Kit;